<!--
 * @Author: zb
 * @LastEditors: 请在根目录下.vscode改成你的名字
 * @Date: 2019-08-08 19:40:48
 * @LastEditTime: 2019-09-30 13:43:52
 * @Version: 1.0
 * @Description: 描述
 * @Company: 济南广域软件
 * @Copyright: Copyright (c) Jnwat Soft
 * @Remarks: 备注
 -->
<template>
  <!--首页-->
  <div class="">
    <!--banner-->
    <section class="banner-wrap">
      <div class="banner">
        <img class="banner-img" ondragstart="return false;" src="@/assets/img/banner.png" alt="">
        <article class="hot">
          <div class="hot-main">
            <!--hot   tab切换   header-->
            <div class="hot-header">
              <div
                v-for="(hotTab,hotTabIndex) in hot"
                :key="hotTabIndex"
                :class="[{'hot-header-list-xz':hotXz==hotTabIndex}]"
                class="hot-header-list"
                @click="hotClick(hotTabIndex)"
              >
                {{ hotTab.title }}
              </div>
            </div>
            <!--hot   tab切换   con-->
            <div class="hot-con">
              <el-form v-if="hotXz === 0" ref="form" :model="goodsForm" label-width="80px">
                <el-form-item label="起运地">
                  <el-cascader
                    v-model="goodsForm.startArea"
                    style="width:250px"
                    :options="area"
                    :filterable="true"
                    :props="{ expandTrigger: 'hover' ,
                              checkStrictly: true}"
                    @expand-change="expandChange"
                  />
                </el-form-item>
                <el-form-item label="目的地">
                  <el-cascader
                    v-model="goodsForm.stopArea"
                    style="width:250px"
                    :options="area"
                    :filterable="true"
                    :props="{ expandTrigger: 'hover' ,
                              checkStrictly: true}"
                    @expand-change="expandChange"
                  />
                </el-form-item>
                <el-form-item label="货物类型">
                  <el-select v-model="goodsForm.type" multiple placeholder="请选择">
                    <el-option
                      v-for="item in dictionary.goodsType"
                      :key="item.key"
                      :value="`{&quot;label&quot;:&quot;${item.label}&quot;,&quot;value&quot;:&quot;${item.value}&quot;}`"
                      :label="item.label"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="重量">
                  <el-select v-model="goodsForm.capacity" placeholder="请选择重量">
                    <el-option
                      v-for="item in dictionary.weight"
                      :key="item.key"
                      :value="`{&quot;label&quot;:&quot;${item.label}&quot;,&quot;value&quot;:&quot;${item.value}&quot;}`"
                      :label="item.label"
                    />
                    <!-- <el-option label="30吨以下" value="{&quot;label&quot;:&quot;30吨以下&quot;,&quot;value&quot;:&quot;0-30&quot;}" /> -->
                    <!-- <el-option label="30—200吨" value="{&quot;label&quot;:&quot;30—200吨&quot;,&quot;value&quot;:&quot;30-200&quot;}" />
                    <el-option label="200—1000吨" value="{&quot;label&quot;:&quot;200—1000吨&quot;,&quot;value&quot;:&quot;200-1000&quot;}" />
                    <el-option label="1000—5000吨" value="{&quot;label&quot;:&quot;1000—5000吨&quot;,&quot;value&quot;:&quot;1000-5000&quot;}" /> -->
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" class="hot-con-btn" @click="fastSource">快速查询</el-button>
                </el-form-item>
              </el-form>
              <el-form v-if="hotXz === 1" ref="form" :model="transportForm" label-width="80px">
                <el-form-item label="起运地">
                  <el-cascader
                    v-model="transportForm.startArea"
                    style="width:250px"
                    :options="area"
                    :filterable="true"
                    :props="{ expandTrigger: 'hover' ,
                              checkStrictly: true}"
                    @expand-change="expandChange"
                  />
                </el-form-item>
                <el-form-item label="目的地">
                  <el-cascader
                    v-model="transportForm.stopArea"
                    style="width:250px"
                    :options="area"
                    :filterable="true"
                    :props="{ expandTrigger: 'hover' ,
                              checkStrictly: true}"
                    @expand-change="expandChange"
                  />
                </el-form-item>
                <el-form-item label="货物类型">
                  <el-select v-model="transportForm.type" multiple placeholder="请选择">
                    <el-option
                      v-for="item in dictionary.goodsType"
                      :key="item.key"
                      :value="`{&quot;label&quot;:&quot;${item.label}&quot;,&quot;value&quot;:&quot;${item.value}&quot;}`"
                      :label="item.label"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="重量">
                  <el-select v-model="transportForm.capacity" placeholder="请选择重量">
                    <el-option
                      v-for="item in dictionary.weight"
                      :key="item.key"
                      :value="`{&quot;label&quot;:&quot;${item.label}&quot;,&quot;value&quot;:&quot;${item.value}&quot;}`"
                      :label="item.label"
                    />
                    <!-- <el-option label="30吨以下" value="{&quot;label&quot;:&quot;30吨以下&quot;,&quot;value&quot;:&quot;0-30&quot;}" /> -->
                    <!-- <el-option label="30—200吨" value="{&quot;label&quot;:&quot;30—200吨&quot;,&quot;value&quot;:&quot;30-200&quot;}" />
                    <el-option label="200—1000吨" value="{&quot;label&quot;:&quot;200—1000吨&quot;,&quot;value&quot;:&quot;200-1000&quot;}" />
                    <el-option label="1000—5000吨" value="{&quot;label&quot;:&quot;1000—5000吨&quot;,&quot;value&quot;:&quot;1000-5000&quot;}" /> -->
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" class="hot-con-btn" @click="fastTransport">快速查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </article>
        <article v-if="bannerTitle===0" class="banner-title-box">
          <img class="banner-title-One animated bounceInDown" ondragstart="return false;" src="../../assets/img/home/bannerTxt1.png" alt="">
          <div class="banner-title-bor">
            <img class="banner-title-Two animated bounceInDown" ondragstart="return false;" src="../../assets/img/home/bannerTxt2.png" alt="">
          </div>
        </article>
        <article v-if="bannerTitle===1" class="banner-title-box">
          <img class="banner-title-One animated bounceInDown" ondragstart="return false;" src="../../assets/img/home/bannerTxt3.png" alt="">
          <div class="banner-title-bor2">
            <img class="banner-title-Two animated bounceInDown" ondragstart="return false;" src="../../assets/img/home/bannerTxt4.png" alt="">
          </div>
        </article>
      </div>
      <div class="statistics">
        <div class="statistics-box">
          <div class="statistics-item">
            <div class="item-list">
              <p class="item-list-txt">
                <NumberGrow v-if="statisticsData.source!=null" :value="statisticsData.source" :time="2" color="#7ECEF4" />
                条</p>
              <p class="item-list-name">货源量</p>
              <img class="item-list-bg" ondragstart="return false;" src="../../assets/img/homeBlue.png" alt="">
            </div>
          </div>
          <div class="statistics-item">
            <div class="item-list">
              <p class="item-list-txt">
                <NumberGrow v-if="statisticsData.settled!=null" :value="statisticsData.settled" :time="2" color="#F39800" />
                辆</p>
              <p class="item-list-name">入驻车辆</p>
              <img class="item-list-bg" ondragstart="return false;" src="../../assets/img/homeYellow.png" alt="">
            </div>
          </div>
          <div class="statistics-item">
            <div class="item-list">
              <p class="item-list-txt">
                <NumberGrow v-if="statisticsData.total!=null" :value="statisticsData.total" :time="2" color="#E60012" />
                笔</p>
              <p class="item-list-name">总交易量</p>
              <img class="item-list-bg" ondragstart="return false;" src="../../assets/img/homeRed.png" alt="">
            </div>
          </div>
          <div class="statistics-item">
            <div class="item-list">
              <p class="item-list-txt">
                <NumberGrow v-if="statisticsData.cloud!=null" :value="statisticsData.cloud" :time="2" color="#F39800" />
                ㎡</p>
              <p class="item-list-name">云仓面积</p>
              <img class="item-list-bg" ondragstart="return false;" src="../../assets/img/homeYellow.png" alt="">
            </div>
          </div>
          <div class="statistics-item">
            <div class="item-list">
              <p class="item-list-txt">
                <NumberGrow v-if="statisticsData.pot!=null" :value="statisticsData.pot" :time="2" color="#7ECEF4" />
                m³</p>
              <p class="item-list-name">罐区容积</p>
              <img class="item-list-bg" ondragstart="return false;" src="../../assets/img/homeBlue.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--货源 运力-->
    <section class="main-wrap">
      <swiper ref="mySwiper" :options="swiperOptionMain">
        <swiper-slide class="main-slide">
          <div class="main-item">
            <div class="main-header">
              货源信息
            </div>
            <div class="main-con">
              <div class="main-con-title">
                <ul class="title-ul">
                  <li class="title-li" style="width: 350px">起运地/目的地</li>
                  <li class="title-li" style="width: 200px">货物名称</li>
                  <li class="title-li" style="width: 100px">重量</li>
                  <li class="title-li" style="width: 150px">期望运价</li>
                  <li class="title-li" style="width: 200px">所属企业</li>
                  <li class="title-li" style="width: 200px">发布日期</li>
                </ul>
              </div>
              <div class="main-con-box"  @mouseenter="on_top_enter" @mouseleave="on_top_leave">
                <swiper v-if="sourceData.length>0" :options="swiperOptionSource" style="height: 600px" ref="supplySwiper">
                  <swiper-slide v-for="(item,index) in sourceData" :key="index">
                    <div class="main-con-item">
                      <ul class="item-ul clearfloat">
                        <li class="item-li">
                          <div class="item-li-origin" :title="item.startPlaceLabel">{{ item.startPlaceLabel }}</div>
                          <div class="item-li-icon"><i class="iconfont iconicon-zhidajiantou" /></div>
                          <div class="item-li-destination" :title="item.stopPlaceLabel">{{ item.stopPlaceLabel }}</div>
                        </li>
                        <!--iconyoupin-->
                        <li class="item-li">
                          <i
                            v-for="(list,listIndex) in sourceDictionaries.dictionaries"
                            v-show="item.goodsType==list.value"
                            :key="listIndex"
                            class="iconfont item-li-icon"
                            :class="[{'icone':item.goodsType==1},{'iconyuanyou':item.goodsType==2},{'iconyehuatianranqi':item.goodsType==3},{'iconrunhuayou':item.goodsType==4},{'iconhuagongpin':item.goodsType==5}]"
                          />
                          <p>
                            <span v-for="(list,listIndex) in sourceDictionaries.dictionaries" v-show="item.goodsType==list.value" :key="listIndex">{{ list.label }}</span>
                            -
                            <span>{{ item.goodsName }}</span>
                          </p>
                        </li>
                        <li class="item-li"><span>{{ item.weight }}</span>吨</li>
                        <li class="item-li"><span>{{ item.expectPrice | numFilter }}</span>元</li>
                        <li class="item-li">
                          <el-image :src="item.fileUrl | getImg" lazy />
                          <!-- <img :src="item.fileUrl | getImg" alt=""> -->
                          <p>{{ item.companyName }}</p>
                        </li>
                        <li class="item-li"><span>{{ item.createDate | substring3 }}</span></li>
                      </ul>
                    </div>
                  </swiper-slide>
                </swiper>
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide class="main-slide">
          <div class="main-item">
            <div class="main-header">
              运力信息
            </div>
            <div class="transport">
              <div class="transport-popular">
                <div class="popular-box">
                  <div class="popular-header">热门起运地</div>
                  <ul class="popular-item-ul">
                    <li v-for="(item,itemIndex) in popularDeparture" :key="itemIndex" :title="item.startPlaceLabel" @click="hotDepartureClick(item.startPlace)">{{ item.startPlaceLabel }}</li>
                  </ul>
                </div>
                <div class="popular-box">
                  <div class="popular-header">热门目的地</div>
                  <ul class="popular-item-ul">
                    <li v-for="(item,itemIndex) in popularDestination" :key="itemIndex" :title="item.stopPlaceLabel" @click="hotDestinationsClick(item.stopPlace)">{{ item.stopPlaceLabel }}</li>
                  </ul>
                </div>
                <div class="popular-box">
                  <div class="popular-header">运输方式</div>
                  <ul class="popular-item-ul popular-item-ul-type">
                    <li v-for="(item,itemIndex) in transportMode" :key="itemIndex" :title="item.label" @click="hotTypeShipping(item.value)">{{ item.label }}</li>
                  </ul>
                </div>
              </div>
              <div class="transport-con">
                <div class="transport-con-title">
                  <ul class="title-ul">
                    <li class="title-li" style="width: 350px">起运地/目的地</li>
                    <li class="title-li" style="width: 130px">货物类型</li>
                    <li class="title-li" style="width: 130px">运输方式</li>
                    <li class="title-li" style="width: 180px">所属企业</li>
                    <li class="title-li" style="width: 180px">发布日期</li>
                  </ul>
                </div>
                <div class="transport-con-box" @mouseenter="on_bot_enter" @mouseleave="on_bot_leave">
                  <swiper v-if="transportData.length>0 && transportVisibility==true" ref="transportSwiper" :options="swiperOptionTransport" style="height: 600px">
                    <swiper-slide v-for="(item,index) in transportData" :key="index">
                      <div class="transport-con-item">
                        <ul class="transport-ul clearfloat">
                          <li class="transport-li">
                            <div class="item-li-origin" :title="item.startPlaceLabel">{{ item.startPlaceLabel }}</div>
                            <div class="item-li-icon"><i class="iconfont iconicon-zhidajiantou" /></div>
                            <div class="item-li-destination" :title="item.stopPlaceLabel">{{ item.stopPlaceLabel }}</div>
                          </li>
                          <li class="transport-li">
                            <!--<i class="iconfont iconhuagongpin" />-->
                            <i
                              v-for="(list,listIndex) in sourceDictionaries.dictionaries"
                              v-show="item.goodsType==list.value"
                              :key="listIndex"
                              class="iconfont"
                              :class="[{'icone':item.goodsType==1},{'iconyuanyou':item.goodsType==2},{'iconyehuatianranqi':item.goodsType==3},{'iconrunhuayou':item.goodsType==4},{'iconhuagongpin':item.goodsType==5}]"
                            />
                            <p>
                              <span>{{ item.goodsTypeLabel }}</span>
                            </p>
                          </li>
                          <li class="transport-li" :title="item.transportTypeLabel"><span>{{ item.transportTypeLabel }}</span></li>
                          <li class="transport-li">
                            <el-image :src="item.fileUrl | getImg" lazy />
                            <!-- <img :src="item.fileUrl | getImg" alt=""> -->
                            <p>{{ item.companyName }}</p>
                          </li>
                          <li class="transport-li"><span>{{ item.createDate | substring3 }}</span></li>
                        </ul>
                      </div>
                    </swiper-slide>
                  </swiper>
                </div>
              </div>
            </div>
          </div>
        </swiper-slide>
        <div slot="pagination" class="swiper-pagination swiper-pagination-h" />
      </swiper>
    </section>
    <!-- 综合区域 -->
    <section class="content-wrap">
      <article class="content clearfloat">
        <div class="content-left">
          <!-- 价格指数 -->
          <priceIndex />
          <!-- 实时交易 -->
          <realtimeTrade />
        </div>
        <div class="content-right">
          <!-- 综合企业热榜 -->
          <hotList />
          <!--广告-->
          <div class="advertisement">
            <div v-if="advertisementData.length>0" class="advertisement-item-close" @click="advertisementColose"><i class="iconfont iconguanbi1" />关闭广告</div>
            <div v-for="(item,index) in advertisementData" :key="index" class="advertisement-item">
              <el-image :src="item.img" lazy />
              <!-- <img :src="item.img" alt=""> -->
            </div>
          </div>
        </div>
      </article>
    </section>
    <!--入驻企业-->
    <section class="enterprise-wrap">
      <enterpriseMap />
    </section>
  </div>
</template>

<script>
import { getArea } from '@/api/common'
import { getDict } from '@/api/common'
import * as get from '@/api/home/home.js' // 请求接口
// 组件
// import NumberGrow from './unit/numRoll'

// import enterpriseMap from './unit/enterpriseMap'
// import priceIndex from './unit/priceIndex'
// import realtimeTrade from './unit/realtimeTrade'
// import hotList from './unit/hotList'

import { DatabaseUtil } from '@/utils/databaseUtils'
const dataBase = new DatabaseUtil()

export default {
  name: 'Home',
  components: {
    // NumberGrow,
    // enterpriseMap,
    // priceIndex,
    // realtimeTrade,
    // hotList
    NumberGrow: () => import('./unit/numRoll.vue'), // 数字统计
    enterpriseMap: () => import('./unit/enterpriseMap.vue'), //  地图统计
    priceIndex: () => import('./unit/priceIndex.vue'), // 价格指数
    realtimeTrade: () => import('./unit/realtimeTrade.vue'), // 实时交易
    hotList: () => import('./unit/hotList.vue') // 企业热榜
  },
  filters: {
    numFilter(value) {
      // 截取当前数据到小数点后?位
      const tempVal = parseFloat(value).toFixed(2)
      // const realVal = tempVal.substring(0, tempVal.length - 1)
      return tempVal
    },
    substring3(value) {
      return value.substring(0, value.length - 3)
    }
  },
  data() {
    return {
      area: [],
      dictionary: {},
      // banner tab搜索切换
      hotXz: 0,
      hot: [
        { title: '找货源', list: [{ txt: '1' }] },
        { title: '找运力', list: [{ txt: '2' }] }
      ],
      // banner title切换
      bannerTitle: 0,
      // 图标栏
      statisticsData: {
        source: null,
        settled: null,
        total: null,
        cloud: null,
        pot: null
      },

      // banner 搜索表单
      goodsForm: {
        startArea: [],
        stopArea: [],
        type: [],
        capacity: ''
      },
      transportForm: {
        startArea: [],
        stopArea: [],
        type: [],
        capacity: ''
      },
      // 广告图位
      advertisementData: [
        { img: require('../../assets/img/advertisement1.png') },
        { img: require('../../assets/img/advertisement2.png') }
      ],
      // 货源信息
      sourceData: [],
      // 货源字典
      sourceDictionaries: {
        dictionaries: ''
      },
      // 运力信息
      transportData: [],
      transportVisibility: false,
      // 热门起运地
      popularDeparture: [],
      // 热门目的地
      popularDestination: [],
      // 热门运输方式
      transportMode: [],
      // 信息主体轮播
      swiperOptionMain: {
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        spaceBetween: 50,
        pagination: {
          el: '.swiper-pagination-h',
          clickable: true
        },
        on: {
          slideChangeTransitionEnd: () => {
            // 切换结束时，告诉我现在是第几个slide
            var swiper = this.$refs.mySwiper.swiper
            this.bannerTitle = swiper.activeIndex
          }
        }
      },
      // 货源信息轮播
      swiperOptionSource: {
        direction: 'vertical', // 纵轴
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        loop: true,
        slidesPerView: 7,
        centeredSlides: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false
        }
      },
      // 运力信息轮播
      swiperOptionTransport: {
        direction: 'vertical', // 纵轴
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        loop: true, // 开启自动播放
        slidesPerView: 7, // 排放多少个
        centeredSlides: true, // 循环播放
        autoplay: {
          delay: 2000, // 自动播放时间
          disableOnInteraction: false
        }
      }
    }
  },
  created() {
    this.getArea()
    this.getDict('goodsType')
    this.getDict('weight')
    // 获取货源，交易，罐区面积，入住车辆， 云仓面积的总计
    get.countData().then(res => {
      this.statisticsData.source = res.result && res.result.goodsNum
      this.statisticsData.total = res.result && res.result.orderNum
      this.statisticsData.cloud = res.result && res.result.storageNum
      this.statisticsData.pot = res.result && res.result.tankNum
      this.statisticsData.settled = res.result && res.result.carNum
    }).catch(() => {
      // 抛出异常的时候
    })
    // 货源量
    // get.columnGoods().then(res => {
    //   this.statisticsData.source = res.result
    // }).catch(() => {
    //   // console.log(error)
    // })
    // // 总交易量
    // get.columnTrade().then(res => {
    //   this.statisticsData.total = res.result
    // }).catch(() => {
    //   // console.log(error)
    // })
    // // 云仓面积
    // get.columnCloud().then(res => {
    //   this.statisticsData.cloud = res.result
    // }).catch(() => {
    //   // console.log(error)
    // })
    // // 罐区面积
    // get.columnPot().then(res => {
    //   this.statisticsData.pot = res.result
    // }).catch(() => {
    //   // console.log(error)
    // })
    // // 入驻车辆
    // get.columnSettled().then(res => {
    //   this.statisticsData.settled = res.result
    // }).catch(() => {
    //   // console.log(error)
    // })
    //
    this.$nextTick(function() {
      //  货源列表
      get.sourceList().then(res => {
        console.log(res)
        this.sourceData = res.result.rows
      }).catch(() => {
        // console.log(error)
      })
      //  运力列表
      get.TransportList().then(res => {
        this.transportData = res.result.rows
        this.transportVisibility = true
      }).catch(() => {
        // console.log(error)
      })
    })
    get.getHotDataList().then(res => {
      this.popularDeparture = res.result['hotStart']
      this.popularDestination = res.result['hotStop']
      this.transportMode = res.result['hotWay']
    }).catch(() => {

    })

    // //  热门起运地
    // get.hotOrigin().then(res => {
    //   console.log(res)
    //   this.popularDeparture = res.result
    // }).catch(() => {
    //   // console.log(error)
    // })
    // //  热门目的地
    // get.hotDestination().then(res => {
    //   this.popularDestination = res.result
    // }).catch(() => {
    //   // console.log(error)
    // })
    // //  热门运输方式
    // get.hotMode().then(res => {
    //   this.transportMode = res.result
    // }).catch(() => {
    //   // console.log(error)
    // })
  },
  //计算属性，获得可以操作的swiper对象
  computed: {
    supplySwiper() {
      // mySwiper 是要绑定到标签中的ref属性
        return this.$refs.supplySwiper.swiper
    },
    transportSwiper() {
      // mySwiper 是要绑定到标签中的ref属性
        return this.$refs.transportSwiper.swiper
    }
  },
  methods: {
    // 仓库位置点击事件处理
    expandChange() {
      setTimeout(function() {
        var alist = document.getElementsByClassName('el-radio__original')
        if (alist) {
          for (var idx = 0; idx < alist.length; idx++) {
            var mya = alist[idx]
            mya.style.cssText = 'width:160px;height:34px;z-index:1;top:-10px;cursor:inherit'
          }
        }
      }, 300)
    },
    getArea() {
      if (dataBase.localStorageUtil.has('area')) {
        this.area = JSON.parse(dataBase.localStorageUtil.get('area'))
      } else {
        getArea()
          .then(data => {
            dataBase.localStorageUtil.set('area', JSON.stringify(data.result))
            this.area = data.result
          })
          .catch(error => {
            console.error(error)
          })
      }
    },
    getDict(type) {
      if (dataBase.sessionStorageUtil.has(type)) {
        this.dictionary[type] = JSON.parse(dataBase.sessionStorageUtil.get(type))
        if (type === 'goodsType') {
          this.sourceDictionaries.dictionaries = JSON.parse(dataBase.sessionStorageUtil.get(type))
        }
      } else {
        getDict(type)
          .then(data => {
            dataBase.sessionStorageUtil.set(type, data.result)
            this.dictionary[type] = JSON.parse(data.result)
            if (type === 'goodsType') {
              this.sourceDictionaries.dictionaries = JSON.parse(data.result)
            }
          })
          .catch(error => {
            console.error(error)
          })
      }
    },
    // banner form 切换
    hotClick(index) {
      this.hotXz = index
    },
    // 快速查询 货源信息
    fastSource() {
      console.log(650, this.dictionary)
      this.$router.push({
        name: 'SourceNews',
        params: { goodsForm: JSON.parse(JSON.stringify(this.goodsForm)) }
      })
    },
    //鼠标悬停
    on_top_enter() {
      this.supplySwiper.autoplay.stop()
    },
    on_top_leave() {
      this.supplySwiper.autoplay.start()
    },
    on_bot_enter() {
      this.transportSwiper.autoplay.stop()
    },
    on_bot_leave() {
      this.transportSwiper.autoplay.start()
    },
    // 快速查询 运力信息
    fastTransport() {
      this.$router.push({
        name: 'TransportNews',
        params: { home: true, transportForm: JSON.parse(JSON.stringify(this.transportForm)) }
      })
    },
    // 运力列表 热门起运地
    hotDepartureClick(data) {
      get.TransportList({ startPlace: data }).then(res => {
        this.transportData = res.result.rows
        this.transportVisibility = false // 在html里通过v-if='transportVisibility '来控制 变化
        this.$nextTick(() => {
          this.transportVisibility = true
        })
      }).catch(error => {
        console.log(error)
      })
    },
    // 运力列表 热门目的地
    hotDestinationsClick(data) {
      get.TransportList({ stopPlace: data }).then(res => {
        this.transportData = res.result.rows
        this.transportVisibility = false // 在html里通过v-if='transportVisibility '来控制 变化
        this.$nextTick(() => {
          this.transportVisibility = true
        })
      }).catch(error => {
        console.log(error)
      })
    },
    // 运力列表 热门运输方式
    hotTypeShipping(data) {
      get.TransportList({ transportType: data }).then(res => {
        this.transportData = res.result.rows
        this.transportVisibility = false // 在html里通过v-if='transportVisibility '来控制 变化
        this.$nextTick(() => {
          this.transportVisibility = true
        })
      }).catch(error => {
        console.log(error)
      })
    },
    // 关闭广告
    advertisementColose() {
      this.advertisementData = []
    }
  }
}
</script>
<style scoped lang='scss'>
  @import './home.scss';
</style>
<style scoped lang="scss">
  .hot-main /deep/.el-input--suffix .el-input__inner{
    background:rgba(255,255,255,0.5);
  }
  /deep/.swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet{
    display: inline-block;
    width:38px;
    height:9px;
    border-radius:5px;
    background: #BE2316;
  }
</style>
